import { Component, inject } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { LoaderService } from './loader.service';

@Component({
    selector: 'st-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    imports: [LetDirective]
})
export class LoaderComponent {
  private readonly loaderService = inject(LoaderService);

  loaderState$ = this.loaderService.loaderState;
}
